/** Paramètres : 2ᵉ barre + écran courant. */
import { useState } from "react";
import { PageHeader } from "../components/PageHeader";
import { CompanyTab } from "../features/settings/CompanyTab";
import { FormatsTab } from "../features/settings/FormatsTab";
import { PaymentsTab } from "../features/settings/PaymentsTab";
import { SettingsNav } from "../features/settings/SettingsNav";
import { ModelTab } from "../features/settings/ModelTab";
import { EmailTab } from "../features/settings/EmailTab";
import { PortalTab } from "../features/settings/PortalTab";
import { NumberingTab } from "../features/settings/NumberingTab";
import { ProductsTab } from "../features/settings/ProductsTab";
import { TaxesTab } from "../features/settings/TaxesTab";
import { ControlsTab } from "../features/settings/ControlsTab";
import { ImportExportTab } from "../features/settings/ImportExportTab";
import { WorkflowTab } from "../features/settings/WorkflowPanel";
import type { SettingsNavId } from "../features/settings/nav";
import "../features/settings/settings.css";

const TITLES: Record<SettingsNavId, string> = {
  company: "Information sur l’entreprise",
  formats: "Formats",
  taxes: "Taxes",
  products: "Produits",
  model: "Modèles",
  numbering: "Numérotation",
  email: "E-mails",
  portal: "Portail",
  workflow: "Flux de travail",
  payments: "Paiements",
  exchange: "Import / Export",
  controls: "Contrôles",
};

export function SettingsPage() {
  const [section, setSection] = useState<SettingsNavId>("company");

  return (
    <div className="fx-settings">
      <aside className="fx-set-aside">
        <p className="fx-set-aside__title">Paramètres</p>
        <SettingsNav current={section} onSelect={setSection} />
      </aside>
      <div className="fx-set-body">
        <div className="fx-page" key={section}>
          <PageHeader title={TITLES[section]} />
          {section === "company" ? <CompanyTab /> : null}
          {section === "formats" ? <FormatsTab /> : null}
          {section === "taxes" ? <TaxesTab /> : null}
          {section === "products" ? <ProductsTab /> : null}
          {section === "model" ? <ModelTab /> : null}
          {section === "numbering" ? <NumberingTab /> : null}
          {section === "email" ? <EmailTab /> : null}
          {section === "portal" ? <PortalTab /> : null}
          {section === "workflow" ? <WorkflowTab /> : null}
          {section === "payments" ? <PaymentsTab /> : null}
          {section === "exchange" ? <ImportExportTab /> : null}
          {section === "controls" ? <ControlsTab /> : null}
        </div>
      </div>
    </div>
  );
}
